<template>
	<div>
		<div class="s-img">
			<img src="../assets/images/ai/ai-1.jpg" />
		</div>
		<div class="s-img" id="anchor-0">
			<img src="../assets/images/ai/ai-2.jpg" />
		</div>
		<div class="s-img">
			<img src="../assets/images/ai/ai-3.jpg" />
		</div>
		<div class="s-img" id="anchor-1">
			<img src="../assets/images/ai/ai-4.jpg" />
		</div>
		<div class="s-img" id="anchor-2">
			<img src="../assets/images/ai/ai-5.jpg" />
		</div>
		<div class="s-img">
			<img src="../assets/images/ai/ai-6.jpg" />
		</div>
	</div>
	
</template>

<script>
export default {
	data() {
		return {
			anchorList: [
				{ name: '板块一' },
				{ name: '板块二' },
				{ name: '板块三' },
				{ name: '板块四' },
				{ name: '板块五' },
				{ name: '板块六' }
			]
		};
	},
	mounted() {
		// 延迟执行，确保路由守卫的 scrollTo(0,0) 已执行完毕
		setTimeout(() => {
			const anchorIndex = this.$route.query.anchor;
			if(anchorIndex) this.scrollToAnchor(parseInt(anchorIndex));
		}, 100);
	},
	methods: {
		scrollToAnchor(index) {
			const element = document.getElementById(`anchor-${index}`);
			if (element) {
				// 使用 window.scrollTo 替代 scrollIntoView，避免被路由守卫覆盖
				const offsetTop = element.offsetTop;
				window.scrollTo({
					top: offsetTop,
					behavior: 'smooth'
				});
			}
		}
	}
};
</script>

<style>
.textHeight{
	padding-top: 200px;
	height: 100px;
}

/* 锚点导航样式 */
.anchor-nav {
	position: fixed;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	z-index: 1000;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.anchor-item {
	padding: 10px 15px;
	background-color: rgba(138, 186, 70, 0.8);
	color: #fff;
	border-radius: 5px;
	cursor: pointer;
	transition: all 0.3s;
	font-size: 14px;
	white-space: nowrap;
}

.anchor-item:hover {
	background-color: #8aba46;
	transform: translateX(-5px);
}

.s-img {
	width: 100%;
}

.s-img img {
	width: 100%;
	height: auto;
	display: block;
}
</style>